import React from "react";
import Main from "./Main";
import Banner from "./Banner";

/*  MainContainer is the container for the raw app state,
 *  where data is fetched for the menus and processed, where the
 *  query strings are processed and changed, and all data is passed
 *  down to the app.
 */
export default class MainContainer extends React.Component {

    constructor(props) {
    super(props);
    this.state = {};
  }

  async componentWillMount() {
    const dirs = await this.getDirs()
    const data = await this.getData();
    this.setState({ dirs, data });
  }

  /* fetch the list of directories named with date strings */
  async getDirs() {
    let response = await fetch("./data/dateLog.txt", {
      headers: { 'accept': 'text/xml' },
      method: 'GET'
    }).catch(err => { console.log(err) });
    let text = await response.text();
    text = text.split("\n"); //.filter( str => (/(\D+.jpg)/.test(str) && str.length === 8) );
    return text;
  }

  // fetch the json to populate the menus and provide unit rules and limits on cycles
  async getData() {
    let response = await fetch('./data/newse_research.json', {
      headers: { 'accept': 'text/json' },
      method: 'GET'
    }).catch( err => { console.log(err) });
    return response.json();
  }

  // process query strings, if any, and set original state object for the main app
  getInitialState = () => {
    /* the date is d, cycle is c, and the product field is f.
    // these abbreviated variable names are legacy. to change them would confuse scientists?
    // if there's a query string arg for date, cycle, and/or field, use that, else use a default
    // in the case of dates, if formatted like we expect, they will sort early to latest. we want latest by default.  */
    const d = this.getUrlParameter('d') ? this.getUrlParameter('d') : this.state.dirs[0];
    const c = this.getUrlParameter('c') ? this.getUrlParameter('c') : "1900";
    const f = this.getUrlParameter('f') ? this.getUrlParameter('f') : "temp";
    return ({
      selectedDir: d,
      selectedCycle: c,
      selectedField: f,
      selectedUnit: "000",
      selectedFieldUnitType: "minutes"
    })
  }

  /* make sure the directories fit the format we want in this case,
  // an 8 digit string YYYYMMDD -- we're not enforcing that format here
  // we're just maing sure the string is length 8
  // there was once a tendency to name directories YYYYMMDD00
  // these cases should have been deleted by now, but just in case we have trimZeros
  */
  /*trimZeros = (dateString) => {
    return dateString.substr(0, 8);
  }*/

  /* Borrowed from https://davidwalsh.name/query-string-javascript */
  // manually grab the query string for the arg we ask for
  getUrlParameter = (name) => {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    let regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    let results = regex.exec(window.location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  };

  // make sure we have data before we render Main
  // we have a fallback on the json. we can pass it as props or fetch it through state.
  render() {
    if(this.state.dates || this.state.data) {
      return (
        <div>
        <Banner>
          <img src={`../newse_research/${this.state.data.banner}`}
               alt="NEWS-E Forecast Viewer"
               onError={ e => {
                 e.target.src="https://wof.nssl.noaa.gov/newse_research/banner_research.jpg"
               }}
          />
        </Banner>
        <Main dirs={this.state.dirs} data={ this.props.data || this.state.data } initialState={this.getInitialState()}/>
        </div>
      )
    } else {
      return ( <div/>  );
    }
  }
}



// WEBPACK FOOTER //
// ./src/MainContainer.js